export default "__VITE_ASSET__028af864__"